import React from 'react'
import './account-settings-page.css'

function AccountSettingsPage() {
  return (
    <div>AccountSettingsPage</div>
  )
}

export default AccountSettingsPage